
const appsTranslations = {
    es: {
        breadcrumbs: {
            title: 'Aplicaciones de Utilidad',
            description: 'Instructivo para la descarga de aplicaciones'
        },
        label: {
            canvas_studen_app: 'Canvas Student App',
            zoom: 'Zoom',
            instrucciones_app_descarga: 'Pasos para descargarla en tu computadora',
            instrucciones_zoom_1: 'Ingresa al',
            instrucciones_app_descarga_2: 'Haz click en “Regístrese, es gratuita”.',
            instrucciones_app_descarga_3: 'Ingresa tu fecha de nacimiento y dale a “Continuar”. ',
            instrucciones_app_descarga_4: 'Finalmente, escribe el correo que usas para estudiar y haz click en “Registrarse”.',
            instrucciones_app_descarga_5: 'Te llegará un mail de activación, ¡selecciona “Activar cuenta” y listo!',
            instrucciones_app_descarga_6: '<strong>Tip:</strong>: conéctate a las charlas desde tu computadora. Así podrás concentrarte y visualizar mejor lo que compartan los docentes.',
            instrucciones_app_mobile: 'Instrucciones App Mobile',
            instrucciones_app_mobile_1: 'En el campo escuela/distrito ingresar: "CEREM"',
            instrucciones_app_mobile_2: 'Aparecerá una sección "cerem.instructure.com" pidiendo el correo y contraseña:',
            instrucciones_app_mobile_3: 'Ingresa las credenciales e inicia sesión.',
        },
    },
    en:  {
    }
};


export default appsTranslations